export const TOAST_DELETE = 'toast/TOAST_DELETE';
export const TOAST_DATA = 'toast/TOAST_DATA';
export const TOAST_PUSH = 'toast/TOAST_PUSH';
export const TOAST_DELETE_BY_INDEX = 'toast/TOAST_DELETE_BY_INDEX';
